import useMeiliSearch from '../hooks/meilisearch'
import City from '../logic/City'
import Airport from '../logic/Airport'

const useAirportSearch = () => {
  const { cities } = useMeiliSearch()

  return async (q) => {
    if (q?.length > 2) {
      try {
        const results = await cities.search(q, {
          limit: 50,
        })
        return results.hits.reduce((options, hit) => {
          options.push(new City(hit).searchOptionFormat)

          if (hit.airports.length > 1) {
            hit.airports.forEach((airport) => {
              options.push(new Airport(airport, hit).searchOptionFormat)
            })
          }

          return options
        }, [])
      } catch (err) {
        console.error(err)
        throw err
      }
    }

    return Promise.resolve([])
  }
}

export default useAirportSearch
